import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  name: string;
  path?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="面包屑导航" className="px-4 md:px-6 py-3">
      <ol className="flex items-center gap-2 text-sm text-foreground-500 flex-wrap">
        <li>
          <Link to="/" className="hover:text-primary-600 transition-colors no-underline text-foreground-500">
            <i className="ri-home-4-line"></i>
            <span className="sr-only">首页</span>
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-xs"></i>
            {item.path ? (
              <Link to={item.path} className="hover:text-primary-600 transition-colors no-underline text-foreground-500">
                {item.name}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium">{item.name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}